"use strict";

exports.__esModule = true;
exports.default = void 0;
var _helpers = require("./helpers");
var Offset = /*#__PURE__*/function () {
  function Offset(offset) {
    this.currentOffset = 0;
    this.targetOffset = 0;
    this.startOffset = 0;
    this.startTime = null;
    this.transitionTime = 1;
    this.count = 1;
    this.setOffset(offset);
  }
  var _proto = Offset.prototype;
  _proto.getOffset = function getOffset() {
    return this.currentOffset;
  };
  _proto.setOffset = function setOffset(offset, count) {
    this.currentOffset = count ? (0, _helpers.modulusPositive)(offset, count) : offset;
    this.startOffset = this.currentOffset;
    this.targetOffset = this.currentOffset;
    this.startTime = null;
  };
  _proto.setTarget = function setTarget(offset, count) {
    this.startOffset = count ? (0, _helpers.modulusPositive)(this.currentOffset, count) : offset;
    this.targetOffset = count ? (0, _helpers.closestDividend)(this.startOffset, offset, count) : offset;
    this.startTime = null;
  };
  _proto.update = function update(time) {
    this.startTime = this.startTime || time;
    var timePassed = (time - this.startTime) / 1000;
    var progress = timePassed / this.transitionTime;
    if (progress >= 1 || this.targetOffset === this.currentOffset) {
      this.setOffset(this.targetOffset);
      return true;
    }
    this.currentOffset = (0, _helpers.lerp)(this.startOffset, this.targetOffset, (0, _helpers.easeOut)(progress));
    return false;
  };
  return Offset;
}();
var _default = exports.default = Offset;